import Vue from "vue";
import App from "./App.vue";
import "./main.css";
import VCalendar from 'v-calendar';
import VueRouter from 'vue-router';
import VueScrollTo from 'vue-scrollto';

Vue.config.productionTip = false;

Vue.use(VueRouter);
Vue.use(VueScrollTo, {
    container: "body",
    duration: 0,
    easing: "ease",
    offset: -1000,
})
Vue.use(VCalendar, {
    componentPrefix: 'vc',  // Use <vc-calendar /> instead of <v-calendar />
});

const router = new VueRouter({
    routes: [
        {
            path: '/:accountId/product/:id',
        },
        {
            name: 'success',
            path: '/:accountId/success/:id',
        }
    ]
})

new Vue({
    render: h => h(App),
    router
}).$mount("#app");
